import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarCheck, ImageOff } from "lucide-react";
import { api } from "../../lib/api";
import { ACTIVITY_TYPES, mediaSrc } from "../../lib/labels";

const fmt = (iso) => new Date(iso).toLocaleDateString("id-ID", { timeZone: "Asia/Jakarta", day: "numeric", month: "short", year: "numeric" });
const I = "/dashboard/investor";

const FarmRow = ({ p }) => (
  <li className="rounded-xl border p-4 space-y-3" data-testid={`weekly-farm-${p.id}`}>
    <div className="flex flex-wrap items-start justify-between gap-2">
      <Link to={`${I}/proyek/${p.id}`} className="min-w-0 font-bold text-slate-900 hover:text-emerald-800 break-words" data-testid={`weekly-farm-link-${p.id}`}>{p.projectCode} · {p.name}</Link>
      <span className={`rounded-full px-3 py-1 text-xs font-bold ${p.verifiedCount ? "bg-emerald-100 text-emerald-800" : "bg-slate-100 text-slate-500"}`} data-testid={`weekly-farm-count-${p.id}`}>
        {p.verifiedCount} kegiatan terverifikasi</span>
    </div>
    {p.verifiedCount > 0 && (
      <p className="text-xs text-slate-600" data-testid={`weekly-farm-types-${p.id}`}>
        {Object.entries(p.activityTypes).map(([t, n]) => `${ACTIVITY_TYPES[t] || t}${n > 1 ? ` ×${n}` : ""}`).join(" · ")}</p>)}
    {p.photos.length ? (
      <div className="grid grid-cols-3 gap-2" data-testid={`weekly-farm-photos-${p.id}`}>
        {p.photos.map((m) => (
          <Link key={m.id} to={m.farmUpdateId ? `${I}/kegiatan/${m.farmUpdateId}` : `${I}/proyek/${p.id}`} className="group block" data-testid={`weekly-photo-${m.id}`}>
            <img src={mediaSrc(m)} alt={m.caption || "Foto kebun"} loading="lazy" className="aspect-square w-full rounded-lg object-cover border transition-transform group-hover:scale-[1.02]" />
            <span className="mt-1 block text-[11px] text-slate-500">{fmt(m.createdAt)}</span>
          </Link>))}
      </div>
    ) : <p className="flex items-center gap-2 text-xs text-slate-500" data-testid={`weekly-farm-nophoto-${p.id}`}><ImageOff className="h-4 w-4" />Belum ada foto terverifikasi.</p>}
  </li>
);

export const WeeklySummary = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/me/weekly-summary").then((r) => setD(r.data)).catch(() => setD(false)); }, []);
  if (!d || !d.projects.length) return null;
  return (
    <section className="mb-6 rounded-xl border bg-white p-4 sm:p-5" data-testid="investor-weekly-summary">
      <div className="mb-4 flex flex-wrap items-end justify-between gap-2">
        <div><p className="flex items-center gap-2 font-bold text-slate-900"><CalendarCheck className="h-4 w-4 text-emerald-800" />Ringkasan 7 Hari Terakhir</p>
          <p className="text-xs text-slate-500" data-testid="weekly-range">{fmt(d.from)} – {fmt(d.to)} · kegiatan yang diverifikasi PT SJI</p></div>
        <p className="text-2xl font-extrabold text-emerald-800" data-testid="weekly-total">{d.totalVerified} <span className="text-xs font-semibold text-slate-500">kegiatan</span></p>
      </div>
      <ul className="grid gap-3 lg:grid-cols-2">{d.projects.map((p) => <FarmRow key={p.id} p={p} />)}</ul>
      <p className="mt-3 text-[11px] text-slate-500">Foto terbaru adalah foto kebun yang sudah disetujui PT SJI (tidak termasuk nota).</p>
    </section>
  );
};
